import React, { Component } from 'react';
import FileListItem from "./FileListItem";

class FileList extends Component{

	render(){
		const { files } = this.props;
		return (
			<ul className="file-list">
				{files.map((file,index) => (<FileListItem key={index} file={file} />))}
			</ul>
		);
	};
}

export default FileList;


// WEBPACK FOOTER //
// ./src/components/common/FileList.js